import { register } from 'register-service-worker';

register(`${process.env.BASE_URL}firebase-messaging-sw.js`, {});
